/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import ReturnInfo from '../ReturnInfo';
import CostInfo from '../CostInfo';
import OrderInfo from '../OrderInfo';
import PickCarInfo from '../PickCarInfo';

interface PropsType {
	enums?: any;
	data?: any;
	permission?: any;
	echoData?: any;
}

const OrderTab: React.FC<PropsType> = props => {
	const { enums, data, permission, echoData } = props || {};
	// tabs配置项
	const items: TabsProps['items'] = [
		{
			key: '1',
			label: '订单信息',
			children: <OrderInfo permission={permission} data={data} enums={enums} />,
		},
		{
			key: '2',
			label: '取车信息',
			children: <PickCarInfo permission={permission} data={data} enums={enums} />,
		},
		{
			key: '3',
			label: '还车信息',
			children: <ReturnInfo permission={permission} data={data} enums={enums}  />,
		},
		{
			key: '4',
			label: '费用信息',
			children: <CostInfo permission={permission} data={data} enums={enums} />,
		},
	];

	return <Tabs defaultActiveKey="1" items={items} />;
};

export default OrderTab;
